import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useRole } from "@/contexts/RoleContext";
import { useUserSession } from "@/hooks/use-user-session";
import { useSelectedStudent } from "@/contexts/SelectedStudentContext";

export function useParentHasExamAssignments() {
  const { userRole } = useRole();
  const { data: session } = useUserSession();
  const { students } = useSelectedStudent();
  const userId = session?.userId ?? null;
  const studentIds = students.map((s) => s.id);
  const studentKey = studentIds.slice().sort().join(",");

  return useQuery({
    queryKey: ["parent-has-exam-assignments", userId, studentKey],
    enabled: userRole === "parent" && !!userId && studentIds.length > 0,
    queryFn: async () => {
      if (studentIds.length === 0) return false;
      const { count } = await supabase
        .from("exam_assignments")
        .select("id", { count: "exact", head: true })
        .in("student_id", studentIds)
        .neq("status", "closed");
      return (count || 0) > 0;
    },
    staleTime: 5 * 60 * 1000,
  });
}
